import React, { useContext, useEffect, useState } from 'react';
import { FaCheck } from 'react-icons/fa';
import { Link } from 'react-router';
import { BASE_URL_API } from '../../../References/URLs';
import ActiveStoreContext from '../../../store/ActiveStoreContext';
import AuthContext from '../../../store/auth-context';
import styles from './CampaignAudience.module.css';

const CampaignAudience = ({ data, setData }) => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext);
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const [audience, setAudience] = useState(data.audience);
    const [searchQuery, setSearchQuery] = useState(''); // State for search filter
    const [selectedAudience, setSelectedAudience] = useState(null); // Track selected audience
    const [isPreviewOpen, setIsPreviewOpen] = useState(false)

    // Example audience data, ideally it would come from an external source or prop
    const [audienceData, setAudienceData] = useState([
        {
            audienceIdentifier: 'sdfkh23fd',
            audienceName: 'All male users',
            audienceDescription: 'All registered male users',
            audienceData: [
                { phoneNumber: '919999648406', clientName: 'Navneet Chandan', gender: 'Male' },
                { phoneNumber: '919999648407', clientName: 'John Doe', gender: 'Male' },
                // Add more users here...
            ],
            isSelected: false,
        },
        {
            audienceIdentifier: 'adfwe56df',
            audienceName: 'All female users',
            audienceDescription: 'All registered female users',
            audienceData: [
                { phoneNumber: '919999648408', clientName: 'Jane Doe', gender: 'Female' },
                { phoneNumber: '919999648409', clientName: 'Sarah Smith', gender: 'Female' },
                // Add more users here...
            ],
            isSelected: false,
        },
        // Add more audience objects here...
    ]);

    const handleAudienceChange = (e) => {
        setAudience(e.target.value);
        setData({ ...data, audience: e.target.value });
    };


    window.onclick = event => event.target.id === "apinccosac" ? setIsPreviewOpen(false) : null
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            setIsPreviewOpen(false)
        }
    });

    const handleSelectAudience = (audienceItem) => {
        // Toggle audience selection
        const updatedAudienceData = audienceData.map((aud) =>
            aud?.audienceIdentifier === audienceItem?.audienceIdentifier
                ? { ...aud, isSelected: !aud?.isSelected }
                : aud
        );
        // Set selected audience in state
        setSelectedAudience(updatedAudienceData?.find((aud) => aud?.isSelected));
        // Update data with selected audience
        setData({ ...data, audience: audienceItem });
    };

    const filteredAudienceData = audienceData?.filter((audienceItem) =>
        audienceItem.audienceName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        audienceItem.audienceDescription.toLowerCase().includes(searchQuery.toLowerCase())
    );



    const getAllAudiences = async () => {
        const getAllAudiencesResponse = await fetch(BASE_URL_API + "getAllAudiences",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore?.storeIdentifier,
                }),
            });

        if (!getAllAudiencesResponse.ok) {
            console.log("Something went wrong : Server Error");
        } else {
            const getAllAudiencesRespo = await getAllAudiencesResponse.json();
            if (getAllAudiencesRespo.status === "success") {
                setAudienceData(getAllAudiencesRespo?.response);
            } else if (getAllAudiencesRespo.message === "tokenExpired") {
                authCtx.logout();
            } else {
                setAudienceData([])
            }
            console.log(getAllAudiencesRespo);
        }
    };

    useEffect(() => {
        getAllAudiences()
    }, [])


    return (
        <div className={styles.container}>
            <div className={styles.headerWrapper}>
                <div className={styles.controlsWrapper}>
                    <div className={styles.searchAudienceWrapper}>
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Search by audience name or description"
                            className={styles.searchInput}
                        />
                    </div>
                    <div className={styles.controlsBtn}>
                        <Link to={`/communications/audience/create-new`}>Create New Audience</Link>
                    </div>
                </div>
            </div>

            <div className={styles.audienceList}>
                {filteredAudienceData?.map((audienceItem) => (
                    <div
                        key={audienceItem.audienceIdentifier}
                        className={`${styles.audienceCard} ${selectedAudience?.audienceIdentifier === audienceItem?.audienceIdentifier ? styles.selected : ''
                            }`}
                        onClick={() => handleSelectAudience(audienceItem)}
                    >
                        <div>
                            <div className={styles.audienceName}>{audienceItem.audienceName}</div>
                            <div className={styles.audienceDescription}>{audienceItem.audienceDescription}</div>
                        </div>
                        <div className={styles.preview}>
                            {audienceItem?.audienceData?.slice(0, 2).map((user, index) => (
                                <div key={index}>
                                    <p>{user.clientName} - {user.phoneNumber}</p>
                                </div>
                            ))}
                            <div className={styles.totalCount}>
                                {audienceItem?.audienceData?.length > 2 && <p>+ {audienceItem?.audienceData?.length - 2} more</p>}
                            </div>
                        </div>
                        <div className={styles.acardFooter}>
                            <div className={styles.createdOn}>
                                Created on {audienceItem?.createdOn}
                            </div>
                            <div className={styles.actionWrapper}>
                                <div onClick={() => setIsPreviewOpen(true)} className={styles.previewBtn} >
                                    Preview
                                </div>
                                {selectedAudience?.audienceIdentifier === audienceItem?.audienceIdentifier ?
                                    <div className={styles.selectBtnSelected}>
                                        <span>
                                            <FaCheck /> Selected
                                        </span>
                                    </div>
                                    :
                                    <div className={styles.selectBtn}>
                                        <span>
                                            Select
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {isPreviewOpen && (
                <div className={styles.selectedAudience}>
                    <div className={styles.selectedAudienceContainer} id="apinccosac">
                        <div className={styles.selectedAudienceContent}>
                            <div className={styles.audienceHeader}>
                                <div className={styles.audienceName} >{selectedAudience.audienceName}</div>
                                <div className={styles.audienceDescription}>{selectedAudience.audienceDescription}</div>
                            </div>
                            <div className={styles.sacContent}>
                                {selectedAudience?.audienceData?.map((user, index) => (
                                    <div key={index} className={styles.eachItem} >
                                        <div className={styles.clientName} >{user?.clientName}</div>
                                        <div>{user?.phoneNumber}</div>
                                        <div>{user?.gender}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <button
                className={styles.nextBtn}
                onClick={() => {
                    // Proceed to next step after audience selection
                    if (selectedAudience) {
                        // Handle next step, like navigating to the next page
                        console.log('Audience selected:', selectedAudience);
                    } else {
                        console.log('No audience selected');
                    }
                }}
            >
                Next
            </button>
        </div>
    );
};

export default CampaignAudience;
